import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { RegistrationSharedService } from '../registration-shared.service';
import { RegistrationService } from '../registration.service';
import { PlansService } from '@pedix-workspace/data-access';
import { TranslocoDirective } from '@jsverse/transloco';
import { SteperComponent } from '../steper/steper.component';
@Component({
    selector: 'app-register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss'],
    imports: [
        TranslocoDirective,
        SteperComponent,
        RouterOutlet,
    ]
})
export class RegisterFormComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private registrationSharedService = inject(RegistrationSharedService);
  private plansService = inject(PlansService);
  private registrationService = inject(RegistrationService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  
  constructor() {}

  ngOnInit() {
    this.plansService
      .getPlanPrices()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(plans => {
        const { queryParams } = this.activatedRoute.snapshot;

        const seller = queryParams?.seller || '';
        const planType = queryParams?.planType.toUpperCase();
        const countryCode = queryParams?.countryCode.toUpperCase();
        const billingType = queryParams?.billingType.toUpperCase();
        const promotionCode = queryParams?.promotionCode;
        const businessCategory = queryParams?.businessCategory;

        const planPrice = plans[planType]?.prices[billingType][countryCode] || plans[planType]?.prices[billingType]['XX'];

        this.plansService.planType = planType;
        this.registrationSharedService.selectedPlan = plans[planType];
        this.registrationSharedService.promotionCode = promotionCode;

        this.registrationService.priceOption = planPrice;
        this.registrationSharedService.registrationData.planType = planType;
        this.registrationSharedService.registrationData.establishment.countryCode = countryCode;
        this.registrationSharedService.registrationData.seller = seller;
        this.registrationSharedService.registrationData.billingType = billingType;
        this.registrationSharedService.businessCategory = businessCategory;

        this.router.navigate(['/customer'], {
          relativeTo: this.activatedRoute,
          skipLocationChange: true,
        });
      });
  }
}
